import ApiService from '../../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

const DEFAULT = {
    name: '',
    email: '',
    commission: '',
    password: Math.random().toString(36).slice(-8),
    payment_details: {
        inn: '',
        address: '',
        bik: '',
        r_c: '',
        k_c: '',
        signer: ''
    },
    id: '',
    referral_slug: null,
    referral_commission: 0,
    type: 1,
    referral_enabled: false,
    locale: window.laravel.locale,
    pickup_enabled: false,
    pickups: [],
    clone: () => {
        return JSON.parse(JSON.stringify(DEFAULT));
    }
};

export default {
    namespaced: true,
    state() {
        return {
            form: DEFAULT.clone(),
        }
    },
    mutations: {
      setForm: (state, value) => {
          window.Vue.set(state, 'form', value);
      }
    },
    actions: {
        createPartner({state, commit, getters}, form){
            return new Promise((resolve, reject) => {
                ApiService.post('/partner', form)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        updatePartner({state, commit, getters}, {id, form}) {
            return new Promise((resolve, reject) => {
                ApiService.update('/partner/'+ id, form)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        resetForm({commit}) {
            commit('setForm', DEFAULT.clone());
        },
    }
};
